import type React from "react";

type Organization = {
  id: number;
  name: string;
  state?: string;
  city?: string;
};

interface Props {
  org: Organization;
  onClear: () => void;
}

export const SelectedOrg: React.FC<Props> = ({ org, onClear }) => {
  const location = [org.city, org.state].filter(Boolean).join(", ");
  return (
    <div className="sid-selected-org__container">
      <div className="sid-selected-org__name">
        {org.name}
        {location && <span className="sid-selected-org__location">{location}</span>}
      </div>
      <button
        className="sid-selected-org__clear"
        // TODO: get a translatable accessible name for this button
        aria-label="clear selection"
        onClick={onClear}
      >
        ✕
      </button>
    </div>
  );
};
